import { createAction } from 'redux-act';

export const setZipCodeDecisions = createAction('Set Zip code decisions');
export const setValidationFlag = createAction('Set Zip code validation flag');

export const preZipCodeValidation = createAction('Pre Zip code validation');
export const setZipCodeInfo = createAction('Set Zip code info');

export const validateZipCode = createAction('Validate Zip code');

export const zipCodeReset = createAction('Reset Zip code state');
